import React from 'react';
import StatusBadge from './StatusBadge';

interface TimelineEvent {
  status: string;
  label: string;
  timestamp?: string;
  actor?: string;
  notes?: string;
}

interface OrderTimelineProps {
  events: TimelineEvent[];
  currentStatus?: string;
}

const OrderTimeline: React.FC<OrderTimelineProps> = ({ events, currentStatus }) => {
  if (!events || events.length === 0) {
    return (
      <div className="text-center py-6 text-gray-400 text-sm">
        No history events recorded yet.
      </div>
    );
  }

  return (
    <div className="relative pl-6">
      <div className="absolute left-2 top-0 bottom-0 w-px bg-gray-200" />
      {events.map((event, idx) => (
        <div key={idx} className="relative mb-4 last:mb-0">
          <div className={`absolute -left-4 top-1 w-3 h-3 rounded-full border-2 bg-white
            ${event.status === currentStatus ? 'border-green-500' : 'border-gray-300'}`} />
          <div>
            <div className="flex items-center gap-2">
              <StatusBadge status={event.status} size="sm" />
              <span className="text-sm font-medium text-gray-700">{event.label}</span>
            </div>
            {event.timestamp && (
              <p className="text-xs text-gray-400 mt-0.5">
                {new Date(event.timestamp).toLocaleString()}
                {event.actor && ` · ${event.actor}`}
              </p>
            )}
            {event.notes && <p className="text-xs text-gray-500 mt-1 italic">{event.notes}</p>}
          </div>
        </div>
      ))}
    </div>
  );
};

export default OrderTimeline;
